/**
 * Sets $el.getSafeVal which returns value of the element and
 * fails gracefully if element is not found
 */
var getSafeValue = function () {
    $.fn.getSafeVal = function (safeValue) {
        var $el = $(this);

        if (!$el || !$el.length) return safeValue;

        try {
            return $el.val();
        } catch (e) {
            return safeValue;
        }
    };
};

module.exports = getSafeValue();
